import FormattedMessage from 'I18n/components/FormattedMessage';
import { NextIcon, PreviousIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FindPartnerWizardFooter({
  disableNextButton,
  isFirstStep,
  isLastStep,
  onClickNext,
  onClickBack,
  onClickDone,
  onClickSkip
}) {
  const renderedBackButton = useMemo(() => {
    if (isFirstStep) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Button, {
      onClick: () => onClickBack(),
      use: "secondary",
      children: [/*#__PURE__*/_jsx(PreviousIcon, {
        size: "300"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.back"
      })]
    });
  }, [isFirstStep, onClickBack]);
  const renderedNextButton = useMemo(() => /*#__PURE__*/_jsxs(Button, {
    "data-test-id": "findPartnerWizard-next-button",
    disabled: disableNextButton,
    onClick: () => onClickNext(),
    use: "primary",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.next"
    }), /*#__PURE__*/_jsx(NextIcon, {
      size: "300"
    })]
  }), [disableNextButton, onClickNext]);
  const renderedDonebutton = useMemo(() => /*#__PURE__*/_jsxs(Button, {
    "data-test-id": "findPartnerWizard-see-results-button",
    onClick: () => onClickDone(),
    use: "primary",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.done"
    }), /*#__PURE__*/_jsx(NextIcon, {
      size: "300"
    })]
  }), [onClickDone]);
  const renderedSkipButton = useMemo(() => {
    if (isFirstStep || isLastStep) {
      return null;
    }
    return /*#__PURE__*/_jsx(Button, {
      marginInlineEnd: "400",
      onClick: () => {
        onClickSkip();
      },
      use: "unstyled",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.buttons.skip"
      })
    });
  }, [isFirstStep, isLastStep, onClickSkip]);
  return /*#__PURE__*/_jsxs(DialogFooter, {
    align: "between",
    children: [renderedBackButton, /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "end",
      flex: 1,
      children: [renderedSkipButton, isLastStep ? renderedDonebutton : renderedNextButton]
    })]
  });
}